import React from "react";

// state
import {
  ITrainingForm,
  ITrainingFormErrors,
} from "../../../store/types/training";
import { useAppSelector } from "../../../store";

const useEditTraining = () => {
  const training = useAppSelector(({ training }) => training.training);
  const [image, imageSet] = React.useState<string>("");
  const [data, dataSet] = React.useState<ITrainingForm & { id: string }>({
    name: "",
    body: "",
    address: "",
    link: "",
    date: "",
    duration: "",
    amount: "",
    image: "",
    state_id: "",
    country_id: "",
    id: "",
  });

  const [error, errorSet] = React.useState<ITrainingFormErrors>({
    name: "",
    body: "",
    state_id: "",
    address: "",
    link: "",
    amount: "",
    date: "",
    duration: "",
    image: "",
  });

  const onValidate = () => {
    let err;
    if (!data.name) {
      err = true;
      errorSet((prev) => ({ ...prev, name: "warning" }));
    }
    if (!data.body) {
      err = true;
      errorSet((prev) => ({ ...prev, body: "warning" }));
    }
    if (!data.state_id) {
      err = true;
      errorSet((prev) => ({ ...prev, state_id: "warning" }));
    }
    if (!data.amount) {
      err = true;
      errorSet((prev) => ({ ...prev, amount: "warning" }));
    }
    if (!data.date) {
      err = true;
      errorSet((prev) => ({ ...prev, date: "warning" }));
    }
    if (!data.duration) {
      err = true;
      errorSet((prev) => ({ ...prev, duration: "warning" }));
    }
    if (err) return false;
    return true;
  };

  const onLoad = React.useCallback(() => {
    if (training) {
      dataSet({
        name: training.name || "",
        body: training.body || "",
        address: training.address || "",
        link: training.link || "",
        date:
          training.date instanceof Date
            ? training.date.toISOString()
            : training.date || "",
        duration: training?.duration || "",
        amount: training?.amount || "",
        image: training.image || "",
        state_id: String(training.state.id),
        country_id: String(training.country.id),
        id: String(training.id),
      });
      imageSet(training.image);
    }
  }, [training]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return {
    data,
    image,
    error,
    dataSet,
    errorSet,
    onValidate,
  };
};

export default useEditTraining;
